import { Localization } from "../../../common/localizable-component";
import { LinkLocalization } from "./link-types";

export const LINK_LOCALIZATION: Localization<LinkLocalization> = {
  en: {
    ariaLabel: {
      phone: "Call phone number {0}",
      mail: "Send a mail to {0}",
      download: "Download {0}",
      modal: "Navigate to modal"
    },
    copyToClipboard: "Copy to clipboard",
    copyToClipboardAria: "Copy '{TEXT}' to clipboard",
    copiedToClipboard: "Copied to clipboard"
  },
  de: {
    ariaLabel: {
      phone: "Rufe {0} an",
      mail: "Verfasse eine E-Mail an {0}",
      download: "{0} herunterladen",
      modal: "Navigiere zu Modal"
    },
    copyToClipboard: "In Zwischenablage kopieren",
    copyToClipboardAria: "'{TEXT}' in Zwischenablage kopieren",
    copiedToClipboard: "In Zwischenablage kopiert"
  },
  sv: {
    ariaLabel: {
      phone: "Ring telefonnummer {0}",
      mail: "Skicka e-post till {0}",
      download: "Ladda ner {0}",
      modal: "Gå till modal"
    },
    copyToClipboard: "Kopiera till urklipp",
    copyToClipboardAria: "Kopiera '{TEXT}' till urklipp",
    copiedToClipboard: "Kopierad till urklipp"
  },
  nl: {
    ariaLabel: {
      phone: "Bel telefoonnummer {0}",
      mail: "Stuur een mail naar {0}",
      download: "Download {0}",
      modal: "Navigeer naar Modaal"
    },
    copyToClipboard: "Kopiëren naar klembord",
    copyToClipboardAria: "Kopieer '{TEXT}' naar klembord",
    copiedToClipboard: "Gekopieerd naar klembord"
  },
  it: {
    ariaLabel: {
      phone: "Chiama il numero di telefono {0}",
      mail: "Manda una mail a {0}",
      download: "Carica {0}",
      modal: "Passa alla modale"
    },
    copyToClipboard: "Copia negli appunti",
    copyToClipboardAria: "Copia '{TEXT}' negli appunti",
    copiedToClipboard: "Copiato negli appunti"
  },
  hu: {
    ariaLabel: {
      phone: "Telefonszám hívása {0}",
      mail: "Üzenet küldése {0}",
      download: "{0} db fájl letöltése",
      modal: "Tovább a felugró ablakra"
    },
    copyToClipboard: "Másolás vágólapra",
    copyToClipboardAria: "Másolás '{TEXT}' a vágólapra",
    copiedToClipboard: "Másolva a vágólapra"
  },
  da: {
    ariaLabel: {
      phone: "Ring til nummer {0}",
      mail: "Send mail til {0}",
      download: "Download {0}",
      modal: "Gå til modal"
    },
    copyToClipboard: "Kopier til udklipsholder",
    copyToClipboardAria: "Kopier '{TEXT}' til udklipsholder",
    copiedToClipboard: "Kopieret til udklipsholder"
  },
  fr: {
    ariaLabel: {
      phone: "Appeler le numéro de téléphone {0}",
      mail: "Envoyer un mail à {0}",
      download: "Télécharger {0}",
      modal: "Naviguer vers la modale"
    },
    copyToClipboard: "Copier dans le presse-papiers",
    copyToClipboardAria: "Copier '{TEXT}' dans le presse-papiers",
    copiedToClipboard: "Copié dans le presse-papiers"
  },
  es: {
    ariaLabel: {
      phone: "Llama al número de teléfono {0}",
      mail: "Enviar un email a {0}",
      download: "Descargar {0}",
      modal: "Navegar al modal"
    },
    copyToClipboard: "Copiar al portapapeles",
    copyToClipboardAria: "Copiar '{TEXT}' al portapapeles",
    copiedToClipboard: "Copiado al portapapeles"
  },
  pl: {
    ariaLabel: {
      phone: "Zadzwoń pod numer telefonu {0}",
      mail: "Wyślij maila na adres {0}",
      download: "Pobierz {0}",
      modal: "Przejdź do modalu"
    },
    copyToClipboard: "Kopiuj do schowka",
    copyToClipboardAria: "Kopiuj '{TEXT}' do schowka",
    copiedToClipboard: "Skopiowano do schowka"
  },
  ro: {
    ariaLabel: {
      phone: "Sună la numărul de telefon {0}",
      mail: "Trimiteți un e-mail la {0}",
      download: "Descărcați {0}",
      modal: "Navigați către modal"
    },
    copyToClipboard: "Copiază în clipboard",
    copyToClipboardAria: "Copiază '{TEXT}' în clipboard",
    copiedToClipboard: "Copiat în clipboard"
  },
  hr: {
    ariaLabel: {
      phone: "Nazovi telefonski broj {0}",
      mail: "Pošalji e-poštu na {0}",
      download: "Preuzmi {0}",
      modal: "Idite na modal"
    },
    copyToClipboard: "Kopiraj u međuspremnik",
    copyToClipboardAria: "Kopiraj '{TEXT}' u međuspremnik",
    copiedToClipboard: "Kopirano u međuspremnik"
  },
  cs: {
    ariaLabel: {
      phone: "Volejte na telefonní číslo {0}",
      mail: "Pošlete mail na {0}",
      download: "Stáhnout {0}",
      modal: "Přejít do modálního okna"
    },
    copyToClipboard: "Kopírovat do schránky",
    copyToClipboardAria: "Kopírovat '{TEXT}' do schránky",
    copiedToClipboard: "Zkopírováno do schránky"
  },
  sl: {
    ariaLabel: {
      phone: "Pokličite telefonsko številko {0}",
      mail: "Pošljite pošto na {0}",
      download: "Prenesi {0}",
      modal: "Pojdi v modalno okno"
    },
    copyToClipboard: "Kopiraj v odložišče",
    copyToClipboardAria: "Kopiraj '{TEXT}' v odložišče",
    copiedToClipboard: "Kopirano v odložišče"
  }
};
